
export default [
	{
		path: 'trustCenter',
		name: 'trustCenter',
		// component: () => import('../components/index.vue'),
		component: function (resolve) {
			require(['../views/trustCenter/index.vue'], resolve)
		},
	},
	{
		path: 'trustList',
		name: 'trustList',
		// component: () => import('../components/index.vue'),
		component: function (resolve) {
			require(['../views/trustCenter/list.vue'], resolve)
		},
	},
	{
		path: 'trustDetail',
		name: 'trustDetail',
		// component: () => import('../components/index.vue'),
		component: function (resolve) {
			require(['../views/trustCenter/detail.vue'], resolve)
		},
	},
	{
		path: 'trustSignUp',
		name: 'trustSignUp',
		// component: () => import('../components/index.vue'),
		component: function (resolve) {
			require(['../views/trustCenter/signUp.vue'], resolve)
		},
	},
	{
		path: 'trustTraceability',
		name: 'trustTraceability',
		// component: () => import('../components/index.vue'),
		component: function (resolve) {
			require(['../views/trustCenter/traceability.vue'], resolve)
		},
	}
]